module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lm5ju"))).then(() => parcelRequire('fThBo'));